export const returnsTranslations = {
  en: {
    title: 'Complaints and returns',
    new: 'New case',
    customer: 'Customer',
    subject: 'Subject',
    note: 'Details',
    type: 'Case type',
    complaint: 'Complaint',
    return: 'Return',
    severity: 'Severity',
    source: 'Original shipment position',
    quantity: 'Base quantity',
    originalLot: 'Original lot',
    requested: 'Requested',
    received: 'Received',
    quarantine: 'Quarantine',
    warehouse: 'Warehouse',
    location: 'Storage location',
    approve: 'Approve',
    receive: 'Receive into quarantine',
    inspect: 'Inspect',
    release: 'Release stock',
    scrap: 'Scrap',
    sendBack: 'Send back',
    reason: 'Reason',
    reasonSettings: 'Return reasons',
    reasonSettingsHint:
      'Enter a stable code and a complete label in every supported language. Deactivated reasons remain in existing cases.',
    newReason: 'New reason',
    reasonCode: 'Stable code',
    reasonActive: 'Active',

    credit: 'Quantity credit',
    priceCredit: 'Price credit',
    replacement: 'Replacement order',
    refund: 'Record refund',
    refundNotice:
      'Record an already completed refund with payment proof. This action does not send money.',
    proof: 'Payment proof',
    bookingDate: 'Booking date',
    amount: 'Amount',
    close: 'Close case',
    resolution: 'Resolution',
    save: 'Save',
    cancel: 'Cancel',
    retry: 'Retry',
    empty: 'No cases yet. Create a complaint or return.',
    error: 'The operation failed. Your inputs have been retained.',
    loading: 'Loading…',
    saved: 'Saved',
    search: 'Search cases',
    history: 'History',
    evidence: 'Evidence',
    assignee: 'Assignee',
    reasons: 'Reasons',
    code: 'Code',
    translations: 'Translations',
    settings: 'Settings',
    openDocument: 'Open document',
    available: 'Available to return',
    financial: 'Financial measures',
    price: 'Credit per sales unit',
    select: 'Select…',
    unfinishedHint: 'Complete physical inspections and finalize financial drafts before closing.',
    errors: {
      sourceRequired: 'Choose an original shipped position.',
      duplicateSource: 'Choose each source position once.',
      translations: 'Complete every supported language.',
      version: 'The case changed. Reload it before continuing.',
      exceedsShipment:
        'The requested quantity exceeds the original shipment or its remaining return quantity.',
      exceedsReceipt: 'The quantity exceeds the uninspected receipt.',
      unfinished: 'Physical inspections or financial drafts remain open.',
      invalidSource: 'Check the customer, original shipment, lot and invoice references.',
      ambiguousInvoice:
        'Select the invoice together with its original shipment position. Several claimed shipments share this invoice reference; existing ambiguous credit evidence needs clarification.',
      location: 'Choose a valid warehouse and storage location.',
      status: 'This action is unavailable in the current status.',
      closed: 'The case is closed.',
      unsafeRelease: 'Blocked or expired goods cannot be released.',
      exceedsCredit: 'The credit exceeds the original invoice amount.',
      exceedsRefund: 'The refund exceeds the remaining credit.',
      packPrecision: 'This quantity cannot be represented exactly in the saved sales unit.',
      priceRequired: 'Enter a positive price credit.',
    },
    statuses: {
      OPEN: 'Open',
      APPROVED: 'Approved',
      RECEIVED: 'Received',
      INSPECTED: 'Inspected',
      CLOSED: 'Closed',
      CANCELLED: 'Cancelled',
      IN_REVIEW: 'In review',
    },
    review: 'Review case',
    reject: 'Reject case',
    severities: {
      LOW: 'Low',
      MEDIUM: 'Medium',
      HIGH: 'High',
      CRITICAL: 'Critical',
    },
  },
  de: {
    title: 'Reklamationen und Retouren',
    new: 'Neuer Vorgang',
    customer: 'Kunde',
    subject: 'Betreff',
    note: 'Beschreibung',
    type: 'Vorgangsart',
    complaint: 'Reklamation',
    return: 'Retoure',
    severity: 'Schweregrad',
    source: 'Ursprüngliche Lieferposition',
    quantity: 'Menge in Basiseinheit',
    originalLot: 'Ursprüngliche Charge',
    requested: 'Angefragt',
    received: 'Erhalten',
    quarantine: 'Quarantäne',
    warehouse: 'Lager',
    location: 'Lagerplatz',
    approve: 'Freigeben',
    receive: 'In Quarantäne annehmen',
    inspect: 'Prüfen',
    release: 'Bestand freigeben',
    scrap: 'Verschrotten',
    sendBack: 'Zurücksenden',
    reason: 'Grund',
    reasonSettings: 'Retourengründe',
    reasonSettingsHint:
      'Erfassen Sie einen unveränderlichen Code und eine vollständige Bezeichnung in jeder unterstützten Sprache. Deaktivierte Gründe bleiben in bestehenden Fällen erhalten.',
    newReason: 'Neuer Grund',
    reasonCode: 'Unveränderlicher Code',
    reasonActive: 'Aktiv',

    credit: 'Mengengutschrift',
    priceCredit: 'Preisgutschrift',
    replacement: 'Ersatzauftrag',
    refund: 'Erstattung erfassen',
    refundNotice:
      'Erfasse eine bereits ausgeführte Erstattung mit Zahlungsnachweis. Diese Aktion überweist kein Geld.',
    proof: 'Zahlungsnachweis',
    bookingDate: 'Buchungsdatum',
    amount: 'Betrag',
    close: 'Vorgang schließen',
    resolution: 'Lösung',
    save: 'Speichern',
    cancel: 'Abbrechen',
    retry: 'Erneut versuchen',
    empty: 'Noch keine Vorgänge. Lege eine Reklamation oder Retoure an.',
    error: 'Der Vorgang ist fehlgeschlagen. Deine Eingaben bleiben erhalten.',
    loading: 'Wird geladen…',
    saved: 'Gespeichert',
    search: 'Vorgänge suchen',
    history: 'Verlauf',
    evidence: 'Nachweise',
    assignee: 'Verantwortlich',
    reasons: 'Gründe',
    code: 'Code',
    translations: 'Übersetzungen',
    settings: 'Einstellungen',
    openDocument: 'Beleg öffnen',
    available: 'Noch retournierbar',
    financial: 'Finanzielle Maßnahmen',
    price: 'Gutschrift je Verkaufseinheit',
    select: 'Auswählen…',
    unfinishedHint:
      'Schließe die Warenprüfung ab und finalisiere finanzielle Entwürfe vor dem Abschluss.',
    errors: {
      sourceRequired: 'Wähle eine ursprünglich ausgelieferte Position.',
      duplicateSource: 'Wähle jede ursprüngliche Position nur einmal.',
      translations: 'Vervollständige alle unterstützten Sprachen.',
      version: 'Der Vorgang wurde geändert. Lade ihn erneut.',
      exceedsShipment: 'Die Menge überschreitet die Lieferung oder die noch retournierbare Menge.',
      exceedsReceipt: 'Die Menge überschreitet den ungeprüften Wareneingang.',
      unfinished: 'Warenprüfungen oder finanzielle Entwürfe sind noch offen.',
      invalidSource: 'Prüfe Kunde, ursprüngliche Lieferung, Charge und Rechnungsbezug.',
      ambiguousInvoice:
        'Wähle die Rechnung zusammen mit der ursprünglichen Lieferposition. Mehrere reklamierte Lieferungen teilen diesen Rechnungsbezug; bereits vorhandene mehrdeutige Gutschriftnachweise müssen geklärt werden.',
      location: 'Wähle ein gültiges Lager und einen Lagerplatz.',
      status: 'Diese Aktion ist im aktuellen Status nicht möglich.',
      closed: 'Der Vorgang ist geschlossen.',
      unsafeRelease: 'Gesperrte oder abgelaufene Ware darf nicht freigegeben werden.',
      exceedsCredit: 'Die Gutschrift überschreitet den ursprünglichen Rechnungsbetrag.',
      exceedsRefund: 'Die Erstattung überschreitet den offenen Gutschriftbetrag.',
      packPrecision:
        'Die Menge lässt sich in der gespeicherten Verkaufseinheit nicht exakt darstellen.',
      priceRequired: 'Gib eine positive Preisgutschrift an.',
    },
    statuses: {
      OPEN: 'Offen',
      APPROVED: 'Freigegeben',
      RECEIVED: 'Erhalten',
      INSPECTED: 'Geprüft',
      CLOSED: 'Geschlossen',
      CANCELLED: 'Storniert',
      IN_REVIEW: 'In Prüfung',
    },
    review: 'Fall prüfen',
    reject: 'Fall ablehnen',
    severities: {
      LOW: 'Niedrig',
      MEDIUM: 'Mittel',
      HIGH: 'Hoch',
      CRITICAL: 'Kritisch',
    },
  },
  fr: {
    title: 'Réclamations et retours',
    new: 'Nouveau dossier',
    customer: 'Client',
    subject: 'Objet',
    note: 'Description',
    type: 'Type de dossier',
    complaint: 'Réclamation',
    return: 'Retour',
    severity: 'Gravité',
    source: 'Ligne de livraison d’origine',
    quantity: 'Quantité de base',
    originalLot: 'Lot d’origine',
    requested: 'Demandé',
    received: 'Reçu',
    quarantine: 'Quarantaine',
    warehouse: 'Entrepôt',
    location: 'Emplacement',
    approve: 'Approuver',
    receive: 'Recevoir en quarantaine',
    inspect: 'Inspecter',
    release: 'Libérer le stock',
    scrap: 'Mettre au rebut',
    sendBack: 'Renvoyer',
    reason: 'Motif',
    reasonSettings: 'Motifs de retour',
    reasonSettingsHint:
      'Saisissez un code stable et un libellé complet dans chaque langue prise en charge. Les motifs désactivés restent dans les dossiers existants.',
    newReason: 'Nouveau motif',
    reasonCode: 'Code stable',
    reasonActive: 'Actif',

    credit: 'Avoir de quantité',
    priceCredit: 'Avoir de prix',
    replacement: 'Commande de remplacement',
    refund: 'Enregistrer le remboursement',
    refundNotice:
      'Enregistrez un remboursement déjà effectué avec sa preuve de paiement. Cette action ne transfère pas d’argent.',
    proof: 'Preuve de paiement',
    bookingDate: 'Date comptable',
    amount: 'Montant',
    close: 'Clore le dossier',
    resolution: 'Résolution',
    save: 'Enregistrer',
    cancel: 'Annuler',
    retry: 'Réessayer',
    empty: 'Aucun dossier. Créez une réclamation ou un retour.',
    error: 'L’opération a échoué. Vos saisies sont conservées.',
    loading: 'Chargement…',
    saved: 'Enregistré',
    search: 'Rechercher des dossiers',
    history: 'Historique',
    evidence: 'Justificatifs',
    assignee: 'Responsable',
    reasons: 'Motifs',
    code: 'Code',
    translations: 'Traductions',
    settings: 'Paramètres',
    openDocument: 'Ouvrir le document',
    available: 'Encore retournable',
    financial: 'Mesures financières',
    price: 'Avoir par unité de vente',
    select: 'Sélectionner…',
    unfinishedHint:
      'Terminez les inspections physiques et finalisez les brouillons financiers avant la clôture.',
    errors: {
      sourceRequired: 'Choisissez une ligne effectivement livrée.',
      duplicateSource: 'Sélectionnez chaque ligne une seule fois.',
      translations: 'Complétez toutes les langues prises en charge.',
      version: 'Le dossier a changé. Rechargez-le.',
      exceedsShipment: 'La quantité dépasse la livraison ou le solde retournable.',
      exceedsReceipt: 'La quantité dépasse la réception non inspectée.',
      unfinished: 'Des inspections ou brouillons financiers restent ouverts.',
      invalidSource: 'Vérifiez le client, la livraison, le lot et la facture d’origine.',
      ambiguousInvoice:
        'Sélectionnez la facture avec sa ligne de livraison d’origine. Plusieurs livraisons réclamées partagent cette référence ; les justificatifs d’avoir déjà ambigus doivent être clarifiés.',
      location: 'Choisissez un entrepôt et un emplacement valides.',
      status: 'Cette action est indisponible dans cet état.',
      closed: 'Le dossier est clos.',
      unsafeRelease: 'Les marchandises bloquées ou périmées ne peuvent pas être libérées.',
      exceedsCredit: 'L’avoir dépasse le montant de la facture d’origine.',
      exceedsRefund: 'Le remboursement dépasse le solde de l’avoir.',
      packPrecision:
        'La quantité ne peut pas être représentée exactement dans l’unité sauvegardée.',
      priceRequired: 'Saisissez un avoir de prix positif.',
    },
    statuses: {
      OPEN: 'Ouvert',
      APPROVED: 'Approuvé',
      RECEIVED: 'Reçu',
      INSPECTED: 'Inspecté',
      CLOSED: 'Clos',
      CANCELLED: 'Annulé',
      IN_REVIEW: 'En examen',
    },
    review: 'Examiner le dossier',
    reject: 'Refuser le dossier',
    severities: {
      LOW: 'Faible',
      MEDIUM: 'Moyenne',
      HIGH: 'Élevée',
      CRITICAL: 'Critique',
    },
  },
  es: {
    title: 'Reclamaciones y devoluciones',
    new: 'Nuevo caso',
    customer: 'Cliente',
    subject: 'Asunto',
    note: 'Descripción',
    type: 'Tipo de caso',
    complaint: 'Reclamación',
    return: 'Devolución',
    severity: 'Gravedad',
    source: 'Línea de envío original',
    quantity: 'Cantidad base',
    originalLot: 'Lote original',
    requested: 'Solicitado',
    received: 'Recibido',
    quarantine: 'Cuarentena',
    warehouse: 'Almacén',
    location: 'Ubicación',
    approve: 'Aprobar',
    receive: 'Recibir en cuarentena',
    inspect: 'Inspeccionar',
    release: 'Liberar existencias',
    scrap: 'Desechar',
    sendBack: 'Devolver al cliente',
    reason: 'Motivo',
    reasonSettings: 'Motivos de devolución',
    reasonSettingsHint:
      'Introduzca un código estable y una etiqueta completa en cada idioma admitido. Los motivos desactivados permanecen en casos existentes.',
    newReason: 'Nuevo motivo',
    reasonCode: 'Código estable',
    reasonActive: 'Activo',

    credit: 'Abono por cantidad',
    priceCredit: 'Abono por precio',
    replacement: 'Pedido de reposición',
    refund: 'Registrar reembolso',
    refundNotice:
      'Registra un reembolso ya realizado con su justificante. Esta acción no transfiere dinero.',
    proof: 'Justificante de pago',
    bookingDate: 'Fecha contable',
    amount: 'Importe',
    close: 'Cerrar caso',
    resolution: 'Resolución',
    save: 'Guardar',
    cancel: 'Cancelar',
    retry: 'Reintentar',
    empty: 'No hay casos. Crea una reclamación o devolución.',
    error: 'La operación falló. Se conservan tus datos.',
    loading: 'Cargando…',
    saved: 'Guardado',
    search: 'Buscar casos',
    history: 'Historial',
    evidence: 'Justificantes',
    assignee: 'Responsable',
    reasons: 'Motivos',
    code: 'Código',
    translations: 'Traducciones',
    settings: 'Configuración',
    openDocument: 'Abrir documento',
    available: 'Disponible para devolver',
    financial: 'Medidas financieras',
    price: 'Abono por unidad de venta',
    select: 'Seleccionar…',
    unfinishedHint:
      'Completa las inspecciones y finaliza los borradores financieros antes de cerrar.',
    errors: {
      sourceRequired: 'Selecciona una línea realmente enviada.',
      duplicateSource: 'Selecciona cada línea original una sola vez.',
      translations: 'Completa todos los idiomas admitidos.',
      version: 'El caso ha cambiado. Recárgalo.',
      exceedsShipment: 'La cantidad supera el envío o el saldo disponible.',
      exceedsReceipt: 'La cantidad supera la recepción pendiente de inspección.',
      unfinished: 'Quedan inspecciones o borradores financieros pendientes.',
      invalidSource: 'Revisa el cliente, envío, lote y factura originales.',
      ambiguousInvoice:
        'Seleccione la factura junto con su línea de envío original. Varios envíos reclamados comparten esta referencia; deben aclararse los justificantes de abono anteriores que sean ambiguos.',
      location: 'Selecciona un almacén y una ubicación válidos.',
      status: 'La acción no está disponible en este estado.',
      closed: 'El caso está cerrado.',
      unsafeRelease: 'La mercancía bloqueada o caducada no se puede liberar.',
      exceedsCredit: 'El abono supera el importe de la factura original.',
      exceedsRefund: 'El reembolso supera el saldo del abono.',
      packPrecision: 'La cantidad no se puede representar exactamente en la unidad guardada.',
      priceRequired: 'Introduce un abono de precio positivo.',
    },
    statuses: {
      OPEN: 'Abierto',
      APPROVED: 'Aprobado',
      RECEIVED: 'Recibido',
      INSPECTED: 'Inspeccionado',
      CLOSED: 'Cerrado',
      CANCELLED: 'Cancelado',
      IN_REVIEW: 'En revisión',
    },
    review: 'Revisar caso',
    reject: 'Rechazar caso',
    severities: {
      LOW: 'Baja',
      MEDIUM: 'Media',
      HIGH: 'Alta',
      CRITICAL: 'Crítica',
    },
  },
  tr: {
    title: 'Şikâyetler ve iadeler',
    new: 'Yeni kayıt',
    customer: 'Müşteri',
    subject: 'Konu',
    note: 'Açıklama',
    type: 'Kayıt türü',
    complaint: 'Şikâyet',
    return: 'İade',
    severity: 'Önem derecesi',
    source: 'Orijinal sevkiyat satırı',
    quantity: 'Temel miktar',
    originalLot: 'Orijinal parti',
    requested: 'Talep edilen',
    received: 'Alınan',
    quarantine: 'Karantina',
    warehouse: 'Depo',
    location: 'Depo konumu',
    approve: 'Onayla',
    receive: 'Karantinaya al',
    inspect: 'İncele',
    release: 'Stoku serbest bırak',
    scrap: 'Hurdaya ayır',
    sendBack: 'Geri gönder',
    reason: 'Neden',
    reasonSettings: 'İade nedenleri',
    reasonSettingsHint:
      'Sabit bir kod ve desteklenen her dilde tam bir etiket girin. Kapatılan nedenler mevcut vakalarda korunur.',
    newReason: 'Yeni neden',
    reasonCode: 'Sabit kod',
    reasonActive: 'Etkin',

    credit: 'Miktar alacak notu',
    priceCredit: 'Fiyat alacak notu',
    replacement: 'İkame siparişi',
    refund: 'İade ödemesini kaydet',
    refundNotice: 'Gerçekleşmiş iade ödemesini ödeme belgesiyle kaydedin. Bu işlem para göndermez.',
    proof: 'Ödeme belgesi',
    bookingDate: 'Muhasebe tarihi',
    amount: 'Tutar',
    close: 'Kaydı kapat',
    resolution: 'Çözüm',
    save: 'Kaydet',
    cancel: 'İptal',
    retry: 'Yeniden dene',
    empty: 'Henüz kayıt yok. Şikâyet veya iade oluşturun.',
    error: 'İşlem başarısız oldu. Girdileriniz korundu.',
    loading: 'Yükleniyor…',
    saved: 'Kaydedildi',
    search: 'Kayıt ara',
    history: 'Geçmiş',
    evidence: 'Belgeler',
    assignee: 'Sorumlu',
    reasons: 'Nedenler',
    code: 'Kod',
    translations: 'Çeviriler',
    settings: 'Ayarlar',
    openDocument: 'Belgeyi aç',
    available: 'İade edilebilir miktar',
    financial: 'Mali işlemler',
    price: 'Satış birimi başına alacak',
    select: 'Seçin…',
    unfinishedHint: 'Kapatmadan önce fiziksel incelemeleri ve mali taslakları tamamlayın.',
    errors: {
      sourceRequired: 'Gerçekten sevk edilmiş bir satır seçin.',
      duplicateSource: 'Her kaynak satırını bir kez seçin.',
      translations: 'Desteklenen bütün dilleri tamamlayın.',
      version: 'Kayıt değişti. Yeniden yükleyin.',
      exceedsShipment: 'Miktar sevkiyatı veya kalan iade miktarını aşıyor.',
      exceedsReceipt: 'Miktar incelenmemiş kabulü aşıyor.',
      unfinished: 'Açık incelemeler veya mali taslaklar var.',
      invalidSource: 'Müşteri, orijinal sevkiyat, parti ve faturayı kontrol edin.',
      ambiguousInvoice:
        'Faturayı orijinal sevkiyat satırıyla birlikte seçin. Birden fazla talep edilen sevkiyat aynı fatura referansını paylaşır; mevcut belirsiz alacak belgesi kanıtları açıklığa kavuşturulmalıdır.',
      location: 'Geçerli depo ve konum seçin.',
      status: 'Bu işlem mevcut durumda kullanılamaz.',
      closed: 'Kayıt kapalı.',
      unsafeRelease: 'Bloke veya süresi dolmuş mal serbest bırakılamaz.',
      exceedsCredit: 'Alacak orijinal fatura tutarını aşıyor.',
      exceedsRefund: 'İade ödemesi kalan alacağı aşıyor.',
      packPrecision: 'Miktar kayıtlı satış biriminde tam gösterilemiyor.',
      priceRequired: 'Pozitif fiyat alacağı girin.',
    },
    statuses: {
      OPEN: 'Açık',
      APPROVED: 'Onaylı',
      RECEIVED: 'Alındı',
      INSPECTED: 'İncelendi',
      CLOSED: 'Kapalı',
      CANCELLED: 'İptal edildi',
      IN_REVIEW: 'İnceleniyor',
    },
    review: 'Vakayı incele',
    reject: 'Vakayı reddet',
    severities: {
      LOW: 'Düşük',
      MEDIUM: 'Orta',
      HIGH: 'Yüksek',
      CRITICAL: 'Kritik',
    },
  },
} as const;
